import { useParams } from "react-router-dom";



const SinglePage =() => {
     const {id} = useParams();
     

    return (
        <div>

        </div>
    )
}

export default SinglePage;